module.exports = __webpack_public_path__ + "static/img/shop3.9d7d272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop3.png
// module id = tjN6
// module chunks = 2